import { useEffect, useState } from "react";
import { MailWarning, RefreshCw } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export function EmailOutboxAlert() {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/admin/email-outbox").then(({ data }) => setData(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const retry = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.post("/admin/email-outbox/retry");
      if (r.sent > 0) toast.success(`${r.sent} email inviate`);
      if (r.failed > 0) toast.error("Brevo rifiuta ancora l'invio: autorizza l'IP indicato e riprova");
      if (!r.sent && !r.failed) toast("Nessuna email in attesa");
      await load();
    } finally {
      setBusy(false);
    }
  };

  if (!data || data.pending === 0) return null;
  return (
    <div className="mt-6 rounded-md border border-[#C05C45] bg-[#FBEDE9] p-4" data-testid="email-outbox-alert">
      <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3">
        <div className="flex gap-3">
          <MailWarning className="text-[#C05C45] shrink-0 mt-0.5" size={22} />
          <div>
            <p className="font-ui text-sm font-semibold text-[#1A362D]" data-testid="email-outbox-count">
              {data.pending} email non partite: Brevo le ha rifiutate e sono in coda
            </p>
            <p className="font-ui text-xs text-[#5C6B64] mt-1">
              Vengono ritentate in automatico ogni 15 minuti per 7 giorni.
              {data.blocked_ips.length > 0 && (
                <> Autorizza in Brevo → Sicurezza → IP autorizzati: <strong data-testid="email-outbox-ips">{data.blocked_ips.join(", ")}</strong></>
              )}
            </p>
            <ul className="mt-2 space-y-0.5" data-testid="email-outbox-list">
              {data.items.slice(0, 5).map((i) => (
                <li key={i.id} className="font-ui text-xs text-[#1A362D]">
                  {i.subject} → {i.to} <span className="text-[#8A9691]">({i.attempts} tentativi)</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <button
          onClick={retry}
          disabled={busy}
          data-testid="email-outbox-retry-btn"
          className="inline-flex items-center gap-2 rounded-md bg-[#C05C45] px-4 py-2 font-ui text-sm text-white transition-opacity hover:opacity-90 disabled:opacity-50"
        >
          <RefreshCw size={16} className={busy ? "animate-spin" : ""} /> Riprova ora
        </button>
      </div>
    </div>
  );
}
